import React, { FunctionComponent } from "react";

import { MovieContentSubtype } from "../../../common/types/MovieContentSubtype";
import { MovieProvider } from "./context/MovieProvider";
import { MovieInfo } from "./movie-info/MovieInfo";
import { MovieDashboardHeader } from "./MovieDashboardHeader";
import { MovieVersionListingProvider } from "./version-listing/context/MovieVersionListingProvider";
import { MovieVersionListing } from "./version-listing/MovieVersionListing";

interface MovieDashboardProps {
    contentType: MovieContentSubtype;
}

export const MovieDashboard: FunctionComponent<MovieDashboardProps> = (props: MovieDashboardProps) => {
    const { contentType } = props;

    return (
        <MovieProvider>
            <MovieDashboardHeader />
            <MovieInfo contentType={contentType} />
            <MovieVersionListingProvider>
                <MovieVersionListing />
            </MovieVersionListingProvider>
        </MovieProvider>
    );
};
